import React from 'react';
import { education } from '../mock';
import SectionHeader from './SectionHeader';

export default function Education() {
  return (
    <section className="py-20 md:py-28 border-t border-neutral-900">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader kicker={education.kicker} title={education.title} />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7 space-y-12">
            {education.items.map((e) => (
              <div key={e.school} className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8">
                <p className="md:col-span-4 mono text-[11px] tracking-[0.22em] text-neutral-500">{e.period}</p>
                <div className="md:col-span-8">
                  <h3 className="font-display text-white text-[24px] md:text-[30px] leading-[1.05]">{e.school}</h3>
                  <p className="mt-3 text-neutral-300 text-[14px] md:text-[15px]">{e.degree}</p>
                  <p className="mt-2 text-neutral-500 text-[13px] md:text-[14px] leading-relaxed">{e.detail}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-5">
            <p className="mono text-[11px] tracking-[0.22em] text-[#ED2D5C]">CERTIFICATIONS</p>
            <h3 className="font-display text-white text-[26px] md:text-[32px] mt-3">
              {education.certs.title}
            </h3>
            <ul className="mt-6 divide-y divide-neutral-900 border-y border-neutral-900">
              {education.certs.items.map((c, i) => (
                <li key={c} className="py-4 flex items-start gap-4">
                  <span className="mono text-[10px] tracking-[0.22em] text-[#ED2D5C] pt-1">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="text-neutral-300 text-[14px] md:text-[15px]">{c}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
